import React, { useState } from "react";
import { MessageCircle, Phone, Mail, X } from "lucide-react";

export default function FloatingCTA() {
  const [isOpen, setIsOpen] = useState(false);

  const contactOptions = [
    {
      icon: MessageCircle,
      label: "WhatsApp",
      color: "bg-green-500 hover:bg-green-600",
      action: () => {
        window.open(
          "https://wa.me/919473196196?text=Hello, I need help with tax services",
          "_blank"
        );
      },
    },
    {
      icon: Phone,
      label: "Call",
      color: "bg-blue-500 hover:bg-blue-600",
      action: () => {
        window.location.href = "tel:+91 9473196196";
      },
    },
    {
      icon: Mail,
      label: "Email",
      color: "bg-purple-500 hover:bg-purple-600",
      action: () => {
        window.location.href =
          "mailto:helpdesk@gha.org.in?subject=Tax Service Inquiry";
      },
    },
  ];

  return (
    <div className="fixed bottom-6 left-6 z-50">
      <div className="flex flex-col-reverse items-start gap-3">
        {/* Main CTA Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full shadow-2xl flex items-center justify-center text-white transition-all duration-300 hover:scale-110 ${
            isOpen ? "rotate-90" : ""
          }`}
          aria-label="Contact Options"
        >
          {isOpen ? (
            <X className="w-7 h-7" />
          ) : (
            <div className="relative">
              <MessageCircle className="w-7 h-7" />
              <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse"></span>
            </div>
          )}
        </button>

        {/* Contact Options */}
        <div
          className={`flex flex-col-reverse gap-3 transition-all duration-300 ${
            isOpen
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-4 pointer-events-none"
          }`}
        >
          {contactOptions.map((option, idx) => {
            const Icon = option.icon;
            return (
              <div
                key={idx}
                className="flex items-center gap-3 group"
                style={{
                  transitionDelay: isOpen ? `${idx * 50}ms` : "0ms",
                }}
              >
                {/* Button */}
                <button
                  onClick={option.action}
                  className={`w-14 h-14 ${option.color} rounded-full shadow-lg flex items-center justify-center text-white transition-all duration-300 hover:scale-110 hover:shadow-xl`}
                  aria-label={option.label}
                >
                  <Icon className="w-6 h-6" />
                </button>

                {/* Label */}
                <div className="bg-white px-4 py-2 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                  <span className="text-sm font-semibold text-gray-700">
                    {option.label}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
